import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row q-col-gutter-y-md text-center" }
const _hoisted_2 = { class: "col-12 col-sm-6" }
const _hoisted_3 = { class: "text-h5" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "text-body1 text-uppercase" }, "Posts", -1)
const _hoisted_5 = { class: "col-12 col-sm-6" }
const _hoisted_6 = { class: "text-h5" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "text-body1 text-uppercase" }, "Duration", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.postImport.numPosts), 1),
      _hoisted_4
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.duration), 1),
      _hoisted_7
    ])
  ]))
}